<template lang="pug">
  .profile-page-form
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title При въезде на базу отдыха иметь
      .profile-section__body
        .form
          .form__elem(
            v-for="(item, index) in fields.docs"
          )
            .form-elem.form-elem_horizontal
              .form-elem__title {{index === 0 ? "Пункты" : ""}}
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.docs[index]"
                )
          .form__elem
            .form-elem.form-elem_right
              .form-elem__title
              .form-elem__body
                button.button.button_paint-main--light.button_narrow(
                @click.prevent="onAddItem"
                )
                  .button__text Добавить пункт
    section.profile-page-form__section.profile-section
      .profile-section__body
        .form
          .form__elem.form__elem_button
            .form-elem(
            v-if="campData"
            )
              .form-elem__body
                router-link.button.button_long(
                :to="{name: 'CurrentCamp', params: {campId: campData.id}}"
                target="_blank"
                )
                  .button__text Просмотр
            .form-elem
              .form-elem__body
                button.button.button_paint-main.button_long(
                @click.prevent="onSaveCamp"
                )
                  .button__text Сохранить
</template>

<script>

export default {
  name: "ManagerCampEditorDocs",
  props: {
    campData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fields: {
        docs: [""]
      }
    };
  },
  methods: {
    setFields(campData) {
      if (campData.required_documents) {
        this.fields.docs = campData.required_documents.split(";");
      }
    },
    onAddItem() {
      this.fields.docs.push("");
    },
    onSaveCamp() {
      const docs = this.fields.docs.filter(item => {
        if (item.length > 0) {
          return item;
        }
      });
      if (docs.length === 0) {
        docs.push("");
      }
      this.fields.docs = docs;
      const requiredDocuments = docs.join(";");
      const data = {
        required_documents: requiredDocuments
      };
      this.$emit("on-save-camp", data);
    }
  },
  watch: {
    campData(val) {
      this.setFields(val);
    }
  },
  mounted() {
    if (this.campData) {
      this.setFields(this.campData);
    }
  }
};
</script>
